// test1425
(1425 && 0);
